import { Text } from '../Text';

export const ConfirmationStep = (props) => {
  return (
    <div className="p-6">
      <div className="space-y-6">
        <div className="md:text-center space-y-4 max-w-xl mx-auto">
          <Text.H4>Thank you for expressing your interest.</Text.H4>
          <div className="text-sm text-gray-800">
            We will contact you soon with more information.
          </div>
        </div>
      </div>
    </div>
  );
};
